import { useState } from "react";
import { Shield, Clock, CalendarDays, MapPin, AlertTriangle, Percent, Banknote, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import OperatorList from "./OperatorList";
import ClockPage from "./workforce/ClockPage";
import CalendarPage from "./workforce/CalendarPage";
import GeofencePage from "./workforce/GeofencePage";
import AlertsPage from "./workforce/AlertsPage";
import CommissionsPage from "./CommissionsPage";
import PayrollPage from "./PayrollPage";
import PermissionsPanel from "./PermissionsPanel";

const tabs = [
  { key: "operators", label: "Operadores", icon: Shield },
  { key: "clock", label: "Ponto", icon: Clock },
  { key: "calendar", label: "Calendário", icon: CalendarDays },
  { key: "commissions", label: "Comissões", icon: Percent },
  { key: "payroll", label: "Folha Pgto", icon: Banknote },
  { key: "permissions", label: "Permissões", icon: Lock, admin: true },
  { key: "geofences", label: "Geofences", icon: MapPin, admin: true },
  { key: "alerts", label: "Alertas", icon: AlertTriangle, admin: true },
];

export default function OperatorsModule() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [activeTab, setActiveTab] = useState("operators");

  const visibleTabs = tabs.filter((t) => !t.admin || isAdmin);

  return (
    <div data-testid="operators-module">
      {/* Tab navigation */}
      <div className="flex items-center gap-1 overflow-x-auto pb-1 mb-6" style={{ borderBottom: "2px solid var(--crm-border)" }}>
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              data-testid={`tab-${tab.key}`}
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap transition-all relative"
              style={{
                color: active ? "var(--crm-accent)" : "var(--crm-text-muted)",
                borderBottom: active ? "2px solid var(--crm-accent)" : "2px solid transparent",
                marginBottom: "-2px",
              }}
            >
              <Icon className="w-4 h-4" strokeWidth={1.5} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      {activeTab === "operators" && <OperatorList />}
      {activeTab === "clock" && <ClockPage />}
      {activeTab === "calendar" && <CalendarPage />}
      {activeTab === "commissions" && <CommissionsPage />}
      {activeTab === "payroll" && <PayrollPage />}
      {activeTab === "permissions" && <PermissionsPanel />}
      {activeTab === "geofences" && <GeofencePage />}
      {activeTab === "alerts" && <AlertsPage />}
    </div>
  );
}
